export const config = {
  BASE_URL_API: process.env.VUE_APP_BASE_URL_API,
  API_KEY: process.env.VUE_APP_EP_API_KEY,
  SOCKET_URL: process.env.VUE_APP_SOCKET_URL,
  ASSETS_URL: 'https://epayment-dev.one-line.com/public',

  ENDPOINTS: {
    GET_SETTINGS: '/v1/settings/country/{{ country }}',
    GENERATE_ACCESS_TOKEN: '/v1/authentication/generateAccessToken',
    CREATE_PO: '/v1/purchaseOrders',
    GET_PO_DETAILS: '/v1/purchaseOrders/{{ poUid }}',
    CREATE_PAYMENT_TXN: '/v1/paymentTransactions',
    RETRY_PAYMENT_TXN: '/v1/paymentTransactions/retry',
    UPDATE_TXN_STATUS: '/v1/paymentTransactions/{{ transactionUid }}/updateTransactionStatus'
  }
}
